export default "__VITE_ASSET__BuXDjoUN__"